import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { CostCenterMapping } from '../models/cost-center-mapping.model';
import { MappingServiceInterface } from '../admin-page/mapping-service.interface';

@Injectable()
export class CostCenterMappingService implements MappingServiceInterface {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer  + "api/CostCenterMapping/";
    }

    async getItemsToMap(offset: number, totalItems: number, searchText: string, orderBy: string, direction: string, unmappedOnly: boolean): Promise<CostCenterMapping[]> {
        const params = new HttpParams()
            .set('offset', offset.toString())
            .set('totalItems', totalItems.toString())
            .set('searchText', searchText)
            .set('orderBy', orderBy)
            .set('direction', direction)
            .set('unmappedOnly', unmappedOnly.toString());

        return await this._http.get<CostCenterMapping[]>(`${this.apiServer}GetCostCentersToMap`, { params: params }).toPromise<CostCenterMapping[]>();
    }

    async getUnmappedItemCount(): Promise<number> {
        return await this._http.get<number>(`${this.apiServer}GetUnmappedCostCenterCount`).toPromise<number>();
    }

    async saveMapping(mapping: CostCenterMapping) {
        return await this._http.post<CostCenterMapping>(`${this.apiServer}SaveCostCenterMapping`, JSON.stringify(mapping)).toPromise<CostCenterMapping>();
    }
}
